import { InviteesDTO } from '../../Pages/sendInvite/invite'
import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'

const baseUrl = `${getBaseUrl()}/API/v3/Invite`
export const Invite = createApi({
    reducerPath: 'Invite',
    baseQuery: getBaseQuery(baseUrl),
    endpoints: (builder) => ({
        GetInvites: builder.mutation<any, void>({
            query: () => ({
                url: '',
                method: 'GET',
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),

        SendInvite: builder.mutation<any, InviteesDTO>({
            query: (InviteesReq) => ({
                url: '/SendInvite',
                method: 'POST',
                body: InviteesReq,
            }),
        }),

        ResendInvite: builder.mutation<any, any>({
            query: (ReInviteReq) => ({
                url: '/ResendInvite',
                method: 'PUT',
                body: ReInviteReq,
            }),
        }),
    }),
})

// Export the hooks for the API endpoints
export const { useGetInvitesMutation, useSendInviteMutation, useResendInviteMutation } = Invite
